import tokenData from '../../design-tokens/base-tokens.json';
export const MuiAvatar = {
    variants: [
        {
            props: { variant: 'alt' },
            style: {
                background: tokenData.tokens.palette.background.white,
                color: tokenData.tokens.palette.background.blue500,
                fontWeight: 600
            }
        }
    ],
    styleOverrides: {
        root: ({ theme }) => ({
            background: tokenData.tokens.palette.blue.blue500,
            color: tokenData.tokens.palette.background.white,
            ...theme.typography.label
        })
    }
};
export default MuiAvatar;
